import { render, staticRenderFns } from "./PayRangeIdentityFields.vue?vue&type=template&id=545bf144&scoped=true"
import script from "./PayRangeIdentityFields.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeIdentityFields.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeIdentityFields.vue?vue&type=style&index=0&id=545bf144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545bf144",
  null
  
)

export default component.exports